import React, { useState, useRef, useEffect } from "react";
import { MoreVertical, XCircle, TrendingUp, TrendingDown } from "lucide-react";

import ErrorSoundFile from "../../../Sound/error.mp3";
import useSound from "use-sound";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";

const backend = await new Backend().init();

export default function MiniHeader({ reload }) {
  const [open, setOpen] = useState(false);

    const invester = Number(localStorage.getItem("invester"));

  const [play] = useSound(ErrorSoundFile);

  const [loading, setLoading] = useState(false);

  const menuRef = useRef(null);

  // 🔒 Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 🧠 Action handler
  const handleAction = (action) => {
    setOpen(false);

    if (action === "closeAll") {
      SqAll("all");
    }
    if (action === "closeProfit") {
      SqAll("profit");
    }
    if (action === "closeLoss") {
      SqAll("loss");
    }

    console.log(`Action triggered: ${action}`);
  };

  const SqAll = async (type) => {
    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id: localStorage.getItem("id"),
      type: type,
    };

    try {
      const res = await backend.sq_all(data);
      setLoading(false);

      if (res.error === "False") {
        toast.success(res.message);
        reload?.();
      } else {
        if (res.logout === 1) {
          window.LogOut();
        } else {
          play(); // 🔊 play error sound
          toast.error(res.message);
        }
      }
    } catch (err) {
      setLoading(false);
      play();
      toast.error("Failed to execute SQ-OFF-ALL");
    }
  };

  return (
    <div className="flex justify-between items-center relative">
      {/* Left Title */}
      <h2 className="text-[var(--text)] text-sm font-semibold mb-1">
        Standings
      </h2>

      {/* 3-dot Button */}

      {invester === 1 ? null : (
        <button
          onClick={() => setOpen(!open)}
          className="p-1.5 rounded-full  transition"
        >
          <MoreVertical className="w-5 h-5 text-[var(--text)] " />
        </button>
      )}

      {/* Dropdown */}
      {open && (
        <div
          ref={menuRef}
          className="absolute right-0 top-7 bg-[var(--background)] backdrop-[var(--background)]-md border-2 border-[var(--hover)] rounded-xl shadow-xl w-56 overflow-hidden animate-fadeIn z-50"
        >
          <ul className="text-sm text-[var(--text)]">
            <li
              onClick={() => handleAction("closeAll")}
              className="flex items-center gap-2 px-4 py-2.5 hover:bg-blue-50 dark:hover:bg-blue-900/40 cursor-pointer transition-all"
            >
              <XCircle className="w-4 h-4 text-blue-600 dark:text-blue-400" />
              <span>Close All Standing</span>
            </li>
            <li
              onClick={() => handleAction("closeProfit")}
              className="flex items-center gap-2 px-4 py-2.5 hover:bg-green-50 dark:hover:bg-green-900/40 cursor-pointer transition-all"
            >
              <TrendingUp className="w-4 h-4 text-green-600 dark:text-green-400" />
              <span>Close Profit Standing</span>
            </li>
            <li
              onClick={() => handleAction("closeLoss")}
              className="flex items-center gap-2 px-4 py-2.5 hover:bg-red-50 dark:hover:bg-red-900/40 cursor-pointer transition-all"
            >
              <TrendingDown className="w-4 h-4 text-red-600 dark:text-red-400" />
              <span>Close Loss Standing</span>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
